<template>
    <div>
        <div class="head-bar">
            <el-select v-model="datas.add.table_name" clearable filterable placeholder="">
                <el-option :value="item.name" v-for="(item, index) in tables" :key="index"></el-option>
            </el-select>
        </div>
        <el-table v-loading="datas.status == -1" :data="datas.data" @sort-change="_sort" @selection-change="_select">
            <el-table-column prop="id" label="ID" width="100" sortable="custom"></el-table-column>
            <el-table-column prop="COLUMN_NAME" label="字段"></el-table-column>
            <el-table-column prop="COLUMN_COMMENT" label="备注"></el-table-column>
            <el-table-column prop="DATA_TYPE" label="类型"></el-table-column>
            <el-table-column prop="table_name" label="表"></el-table-column>
            <el-table-column label="显示">
                <template slot-scope="scope">
                    <el-switch v-model="scope.row.is_show" :active-value="1" :inactive-value="0"
                        @change="_quick_edit(table, scope.row.id, 'is_show', scope.row.is_show)">
                    </el-switch>
                </template>
            </el-table-column>
            <el-table-column prop="table_name" label="默认显示">
                <template slot-scope="scope">
                    <el-switch v-model="scope.row.is_des" :active-value="1" :inactive-value="0"
                        @change="_quick_edit(table, scope.row.id, 'is_des', scope.row.is_des)">
                    </el-switch>
                </template>
            </el-table-column>
            <el-table-column label="宽度" width="150">
                <template slot-scope="scope">
                    <el-input v-model="scope.row.width" @blur="_quick_edit(table, scope.row.id, 'width', scope.row.width)">
                    </el-input>
                </template>
            </el-table-column>
            <el-table-column label="排序" width="150">
                <template slot-scope="scope">
                    <el-input v-model="scope.row.myorder"
                        @blur="_quick_edit(table, scope.row.id, 'myorder', scope.row.myorder)">
                    </el-input>
                </template>
            </el-table-column>
        </el-table>
        <div class="page-box">
            <el-pagination @size-change="_size" @current-change="_page" :current-page="datas.page"
                :page-sizes="[10, 20, 50, 100]" :page-size="datas.limit" layout="total, sizes, prev, pager, next"
                :total="datas.total">
            </el-pagination>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            table: 'fields',
            datas: {
                add: {
                }
            },
            tables: []
        };
    },
    created() {
        this.datas.add = {
            ...this.datas.add,
            ...this.$route.query || {}
        };
        this._load();
        this._tables();
    },
    methods: {
        _tables() {
            this.$http.post('table/list', {
                limit: 100
            }).then(res => {
                this.tables = res.data.data;
            })
        }
    },
};
</script>
<style lang="scss" scoped>
@import "index.scss";
</style>